import $ from "jquery"

$('.js-form-tooltip').on('click', function(){
    $(this).toggleClass('ph-question-fill ph-x-circle-fill');
    $('.form-tooltip__content').toggle();
});

// wpForm
function onElementInserted(containerSelector, elementSelector, callback) {
    var onMutationsObserved = function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                var elements = $(mutation.addedNodes).find(elementSelector);
                for (var i = 0, len = elements.length; i < len; i++) {
                    callback(elements[i]);
                }
            }
        });
    };

    var target = $(containerSelector)[0];
    var config = { childList: true, subtree: true };
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(onMutationsObserved);    
    observer.observe(target, config);
}

$(window).on('load', function(){
    $('.form-primary').removeClass('form-primary--loading');
});

$(function($){
    $(this).find('.js-form-primary__indicator').html('<span class="form-primary__indicator-span">Step 1</span>');
});



/**
 * Adding up custom prev button on the first wpForm page break action
 * .js-primary-action-first - class
 */
$('.wpforms-page-1 .js-primary-action-first').prepend('<button class="wpforms-page-button wpforms-page-prev js-primary-action-prev">PREV</button>');

$('body').on('click', '.js-primary-action-prev', function() {
    $('.form-primary__actions').removeClass('form-primary__actions--hide');
    $('.form-primary').show();
    $('.form-step').hide();
});

/** 
 * wpForm step 1 
 * Switching with different forms base on created forms on the dashboard 
*/
$('.js-form-primary-next').on('click', function(){
    if ($(".form-primary__radio:checked").length){
        const primaryRadioValue = $(".form-primary__radio:checked").val();
        const primaryRadioValueParse = primaryRadioValue.replace(/\s+/g, '').toLowerCase();

        $('.form-step').hide();
        $('.form-step--' + primaryRadioValueParse).show();

        $('.wpforms-field-container .wpforms-page').each(function(){
            if($(this).index() == 0){
                $(this).show();
            }else{
                $(this).hide();
            }
        });

        $('.form-primary__actions').addClass('form-primary__actions--hide');
        $('.form-primary').hide();
        let scrollTo = $('.form-step:visible').offset().top - 200;
        $('html, body').animate({
            scrollTop: scrollTo
        }, 500);
    }else{
        $(".form-primary__options").addClass('form-primary__error');
    }
});


$('.form-primary__radio').on('change', function() {
    const primaryRadioVal = $('.form-primary__radio:checked').attr('id');

    if ($('.form-primary__radio:checked').length){
        $(".form-primary__options").removeClass('form-primary__error');
    }

    if( $('.form-step--' + primaryRadioVal + ' .wpforms-page').length ){
        $('.form-primary__button').removeClass('form-primary__button--disabled');
    }else{
        $('.js-form-primary__indicator').html('');
        $('.form-primary__button').addClass('form-primary__button--disabled');
    }
});

/** 
 * wpform validation for input type radio and checkbox when input checkbox or radio is set to required
*/
$('.wpforms-field-required').each(function(){
    const wpFormNextButton = $(this).closest('.wpforms-page').find('.wpforms-page-next');

    wpFormNextButton.on('click', function(){
        if( $(this).closest('.wpforms-page').find('.wpforms-field-required:visible input[type=checkbox]').length && !$(this).closest('.wpforms-page').find('.wpforms-field-required:visible input[type=checkbox]:checked').length ){
            $(this).closest('.wpforms-page').addClass('form-primary__error');

            return false;
        }

        if( $(this).closest('.wpforms-page').find('.wpforms-field-required:visible input[type=radio]').length && !$(this).closest('.wpforms-page').find('.wpforms-field-required:visible input[type=radio]:checked').length ){
            $(this).closest('.wpforms-page').addClass('form-primary__error');

            return false;
        }
    });
});

$('.wpforms-field-required input[type=checkbox]').on('change', function() {
    if ($('.wpforms-field-required input[type=checkbox]:checked').length){
        $(this).closest('.wpforms-page').removeClass('form-primary__error');
    }
});

$('.wpforms-field-required input[type=radio]').on('change', function() {
    if ($('.wpforms-field-required input[type=radio]:checked').length){
        $(this).closest('.wpforms-page').removeClass('form-primary__error');
    }
});

/** 
 * form dynamic fields automatic insert input field next to label element on the checkbox or radio type input
*/
$('.dynamic-input').each(function(){
    const classDynamic = $(this).attr('class').split(/\s+/)[2];
    const classDynamicParse = classDynamic.split('-', classDynamic.split('-').length - 1).join(' ');
    const classDynamicParseResult = classDynamicParse.substring(0,1).toUpperCase() + classDynamicParse.substring(1);
    const dynamicInput = $(this).closest('.wpforms-page').find('input[value="' + classDynamicParseResult + '"] + label');

    $(this).insertAfter(dynamicInput);
});

/** 
 * form number field and adding increment and decrement functionality
*/
$('.js-dynamic-input-number').each(function(){
    $(this).closest('li').find('.dynamic-input').append('<span class="dynamic-add js-dynamic-add"></span>');
    $(this).closest('li').find('.dynamic-input').prepend('<span class="dynamic-minus js-dynamic-minus"></span>');
});

$('body').on('click', '.js-dynamic-add', function() {
    $(this).closest('.dynamic-input').find('input[type=text]').val(function(i, val) { return val * 1 + 1 });
});

$('body').on('click', '.js-dynamic-minus', function() {
    $(this).closest('.dynamic-input').find('input[type=text]').val(function(i, val) { return val <= 1 ? 1 : val * 1 - 1 });
});

/** 
 * form indicator
*/
$('.wpforms-field-container .wpforms-page').each(function(index){
    const indexItem = $(this).index() + 2;
    const indexTotal = $(this).closest('.wpforms-field-container').find('.wpforms-page').length + 1;

    // form indicator top
    $(this).prepend('<div class="form-step__indicator">Step ' + indexItem + '</div>');
        
    // form indicator bottom
    if(!$(this).find('.wpforms-field-required:visible').length){
        $('<div class="wpforms-indicator"><span class="wpforms-page-index">Step ' + indexItem + '</span>  </div>').insertBefore($(this).find('.wpforms-page-next'));
    }else{
        let hasLogic = ($(this).find('.wpforms-field-required:visible').closest('.wpforms-field').hasClass('wpforms-conditional-show'));
        if (hasLogic) {
            $('<div class="wpforms-indicator"><span class="wpforms-page-index">Step ' + indexItem + '</span>  </div>').insertBefore($(this).find('.wpforms-page-next'));
        }else{
            $('<div class="wpforms-indicator wpforms-indicator--md"><span class="wpforms-page-index">Step ' + indexItem + '</span> </div>').insertBefore($(this).find('.wpforms-page-next'));
        }
    }

    if($(this).hasClass('last')){
        $('<div class="wpforms-indicator"><span class="wpforms-page-index">Step ' + indexItem + '</span> </div>').insertAfter($(this).find('.wpforms-page-prev'));
    }

    if(!$(this).find('.wpforms-field-required:visible').length && $(this).hasClass('wpforms-page-1')){
        $(this).find('.wpforms-page-prev').addClass('wpforms-page-prev--not-reqiuired');
    }
});


/** 
 * check if page break is not required and insert skip button
*/
$('.wpforms-field-container .wpforms-page').each(function(){
    let requiredField = $(this).find('.wpforms-field-required');
    if(!requiredField.length){
        $('<button class="wpforms-page-button wpforms-page-skip js-button-skip">Skip</button>').insertBefore($(this).find('.wpforms-page-next'));
    }else {
        let hasLogic = ($(this).find('.wpforms-field-required').closest('.wpforms-field').hasClass('wpforms-conditional-show'));
        if (hasLogic) {
            $('<button class="wpforms-page-button wpforms-page-skip js-button-skip">Skip</button>').insertBefore($(this).find('.wpforms-page-next'));
        }
    }
});

/*$('.js-button-skip').each(function(){
    let wpformsPage = $(this).closest('.wpforms-page');
    $(this).on('click', function(){

        wpformsPage.find('select,textarea').val('');
        wpformsPage.find('input').each(function(){
            console.log('$(this)', $(this));
            console.log('type', $(this).attr('type'));
            let type = $(this).attr('type');
            if(type === 'text' || type === 'hidden') $(this).val('');
            if((type === 'radio' || type === 'checkbox' ) && $(this).is(':checked')) $(this).trigger("click");
        }).promise().done( function(){
            console.log("wpforms-page-next", wpformsPage.find('.wpforms-page-next'));
            wpformsPage.find('.wpforms-page-next').click();
            // wpformsPage.find('.wpforms-page-next').trigger('click');
            wpformsPage.find('.wpforms-page-next').trigger('wpformsBeforePageChange');
        } );

    });
});*/

$('.wpforms-uploader').addClass('wpforms-uploader--empty');

/** 
 * when form upload files are added it will parse the filename to limit to 12 characters and replace the original filename
*/
onElementInserted('body', '.dz-filename span', function(element) {
    $('.dz-filename span').each(function(){
        const filenameBase = $(this).text();
        const filenameSplit = filenameBase.split('.');
        const filenameExtension = filenameSplit[1];
        let filenameValue = filenameSplit[0];

        if (filenameValue.length > 12) {
            filenameValue = filenameValue.substring(0, 10);
        }

        const filenameRewrite = filenameValue + '.' + filenameExtension;

        $(this).text(filenameRewrite);
    });

    $('.wpforms-uploader').removeClass('wpforms-uploader--empty');
});

/** 
 * when form thank you section is added to DOM form heading and description is remove()
*/
onElementInserted('body', '.wpforms-thankyou__img', function(element) {
    /*$('html, body').animate({ scrollTop: 0 }, 'slow', function () {
        console.log('done');
        $('.free-estimation__column--form .free-estimation__heading, .free-estimation__column--form .free-estimation__description').remove();
        $('.form-step').addClass('pt-0');
    });*/
});
